import { BiometricAuth } from "@aparajita/capacitor-biometric-auth";
import { isWebPlatform } from "@/application/utils/envInfo";
import type { CheckBiometryResult } from "@aparajita/capacitor-biometric-auth";

export type { CheckBiometryResult, BiometryErrorType } from "@aparajita/capacitor-biometric-auth";
export { BiometryError, BiometryType } from "@aparajita/capacitor-biometric-auth";

export const checkBiometry = async (): Promise<CheckBiometryResult> => {
  return BiometricAuth.checkBiometry();
}

export const biometryAuth = async (): Promise<void> => {
  if (isWebPlatform) return;

  await BiometricAuth.authenticate({
    reason: 'Bestätige deine Identität, um fortzufahren',
    androidTitle: 'Biometrische Anmeldung',
    cancelTitle: 'Abbrechen',
    allowDeviceCredential: true,
    androidConfirmationRequired: false,
  });
};
